
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mathmagic/sponsors",
      function () {
        return require("private-next-pages/mathmagic/sponsors.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mathmagic/sponsors"])
      });
    }
  